import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-custom-box',
    templateUrl: './custom-box.component.html',
    styleUrls: ['./custom-box.component.scss']
})

export class CustomBoxComponent  {
    @Input()
    public boxSize: 'small' | 'large' | 'xlarge' = 'xlarge';

    @Output() buttonClick = new EventEmitter<void>();


    @Input() public headlineHtml: string;

    @Input() public descriptionHtml: string;

    @Input() public link: string;

    @Input() public buttonText: string;

    onButtonClick() {
        this.buttonClick.emit();
    }


}
